define('services/conversationsProtectionService',[
    'lib/lodash4',
    'lib/knockout',
    'jquery',
    'lib/bluebird',
    'config',
    'services/apiCore'
], function (
    _,
    ko,
    $,
    Promise,
    config,
    apiCore
) {
    'use strict';

    var conversationsProtectionService = {

        getProtectionStatus: function(conversationId) {
            return apiCore.v2.post('/recordings/deletionprotection', {"conversationIds": [conversationId]});

        },

        updateProtectionStatus: function(conversationId, protect) {
            return apiCore.v2.put('/recordings/deletionprotection', {"conversationIds": [conversationId]}, {"protect": protect});
        },
    };
    return conversationsProtectionService;

});

